import React from "react";
import { PublicVisitBroadcastDetailsTypes } from "../../../../messages/Visit";
import { Visit } from "../../../../system/AppState/AppVisitsState";
import { formatDates, formatDayOfWeek, formatTimes } from "../../../../utils/dateUtils";
import { withDefault } from "../../../../utils/withDefault";
import { AppList, AppListItem } from "../../../Generic/AppList";

export type FlexiblePatternVisit = Visit.Available & {
  publicVisitBroadcastDetails: PublicVisitBroadcastDetailsTypes.FlexiblePattern;
};

interface Props {
  visit: FlexiblePatternVisit;
}

export const PendingConfirmationVisitDatesFlexiblePattern = ({ visit }: Props) => {
  const { pendingConfirmationShifts } = visit.caregiverVisitEngagementDetails;
  const { startTimeLocal, endTimeLocal } = visit.publicVisitBroadcastDetails;

  return (
    <AppList>
      <AppListItem title={formatDates(startTimeLocal.toLocalDate(), endTimeLocal.toLocalDate())} />
      {withDefault(pendingConfirmationShifts, []).map((shift, i) => (
        <AppListItem
          key={i}
          title={formatDayOfWeek(shift.day)}
          trailing={formatTimes({ startAt: shift.startTime, endAt: shift.endTime })}
        />
      ))}
    </AppList>
  );
};
